import { TLinks } from 'templates/layout/types';

export const SERVICE_LINK_LIST: TLinks[] = [
  {
    label: 'Bespoke Software',
    route: '/bespoke-software',
    transparentNavbar: true,
  },
  {
    label: 'Agile Prototyping',
    route: '/agile-prototyping',
    transparentNavbar: true,
  },
  {
    label: 'Managed IT Services',
    route: '/managed-it-services',
    transparentNavbar: true,
  },
  {
    label: 'Consultancy',
    route: '/consultancy',
    transparentNavbar: true,
  },
  {
    label: 'IT Infrastructure Services',
    route: '/it-infrastructure',
    transparentNavbar: true,
  },
  {
    label: 'Branding & Design',
    route: '/branding-design',
    transparentNavbar: true,
  },
  {
    label: 'Digital Marketing & SEO',
    route: '/digital-marketing',
    transparentNavbar: true,
  },
];

export const ABOUT_LINKS: TLinks[] = [
  {
    label: 'Cookie policy',
    route: '/cookie',
  },
  {
    label: 'Privacy policy',
    route: '/privacy',
  },
  {
    label: 'Terms of use',
    route: '/terms',
  },
];

export const GENERAL_LINKS: TLinks[] = [
  {
    label: 'Home',
    route: '/',
  },
  {
    label: 'Company',
    route: '/company',
  },
  {
    label: 'Blog',
    route: '/blog',
  },
  {
    label: 'Careers',
    route: '/careers',
  },
  {
    label: 'Contact Us',
    route: '/contact-us',
  },
];

export const PRODUCT_LIST_GPM: TLinks[] = [
  {
    label: 'Construction & Civil Engineering',
    route: '/gpm/construction',
  },
  {
    label: 'OSP (Outside Plant) Construction',
    route: '/gpm/osp',
  },
  {
    label: 'Fulfillment Services & Subcontractor Management',
    route: '/gpm/fulfillment-services',
  },
  {
    label: 'Power Grid & Renewable Energy Deployment',
    route: '/gpm/power-grid',
  },
  {
    label: 'Forestry Management & Logging Operations',
    route: '/gpm/forestry-management',
  },
  {
    label: 'Mining & Extraction Operations',
    route: '/gpm/mining',
  },
];

export const PRODUCT_LIST_UTILITIES: TLinks[] = [
  // {
  //   label: 'Utilities One',
  //   route: '/utilities-one',
  // },
  {
    label: 'Patron Trucking',
    route: '/patron-trucking',
  },
];

export const PRODUCT_LIST_LOGISTIC: TLinks[] = [
  {
    label: 'EasiConnect',
    route: '/easiConnect',
  },
  {
    label: 'LED4Free',
    route: '/led4free',
    transparentNavbar: true,
  },
];

export const PRODUCTS_LINKS: TLinks[] = [...PRODUCT_LIST_UTILITIES, ...PRODUCT_LIST_LOGISTIC];

export const ALL_ROUTES: TLinks[] = [
  ...SERVICE_LINK_LIST,
  ...PRODUCT_LIST_UTILITIES,
  ...PRODUCT_LIST_LOGISTIC,
  ...ABOUT_LINKS,
  ...GENERAL_LINKS,
];
